export const ENQUEUE_SNACKBAR = 'ENQUEUE_SNACKBAR';
export const REMOVE_SNACKBAR = 'REMOVE_SNACKBAR';
export const CUSTOM_ERROR = 'CUSTOM_ERROR';
export const CUSTOM_MESSAGE = 'CUSTOM_MESSAGE';
export const CUSTOM_SNACKBAR = 'CUSTOM_SNACKBAR';
